import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { SafeMonitoringStatus } from "../../domain/safe/Models/SafeMonitoringStatus"

interface BlockchainMonitoringState {
  monitoringStatus?: SafeMonitoringStatus
  isLoading: boolean
  error?: string
}

interface BlockchainMonitoringActions {
  fetchMonitoringStatus: () => Promise<SafeMonitoringStatus | undefined>
  reset: () => void
}

type BlockchainMonitoringStore = BlockchainMonitoringState & BlockchainMonitoringActions

export const useBlockchainMonitoringStore = create<BlockchainMonitoringStore>()(
  devtools(
    (set, get) => ({
      monitoringStatus: undefined,
      isLoading: false,
      error: undefined,

      fetchMonitoringStatus: async () => {
        const state = get()
        if (state.isLoading) return undefined

        set({ isLoading: true, error: undefined })

        try {
          const { monitoringStatus } = await window.domain.GetMonitoringStatusSafeUseCase.execute()
          set({ monitoringStatus, isLoading: false })
          return monitoringStatus
        } catch (error) {
          set({ error: (error as Error).message, isLoading: false })
          throw error
        }
      },

      reset: () => {
        set({ monitoringStatus: undefined, isLoading: false, error: undefined })
      },
    }),
    { name: "BlockchainMonitoringStore" },
  ),
)
